// dashboardReducer.js
import {
  GET_JOB_REPORT_REQUEST,
  GET_JOB_REPORT_SUCCESS,
  GET_JOB_REPORT_FAILURE,
} from "../../actionTypes";

const initialState = {
  isLoading: false,
  data: null,
  error: null,
  // is_daily_visit: 0,
};

const getJobReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_JOB_REPORT_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case GET_JOB_REPORT_SUCCESS:
      console.log("gggggg", action.payload);
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        // is_daily_visit: action.payload.data.is_daily_visit,
        error: null,
      };
    case GET_JOB_REPORT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default getJobReportReducer;
